import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useMemo, useEffect } from 'react';
import { CommonClassNames } from '@dtvgo/classnames';
import './ConditionalVisible.scss';
import { jsx } from 'react/jsx-runtime';

var ConditionalVisibleClassNames = CommonClassNames.component('conditional-visible');
var DEFAULT_TRANSITION_SECONDS = 1;
function ConditionalVisible(_ref) {
  var className = _ref.className,
    style = _ref.style,
    visible = _ref.visible,
    transitionSeconds = _ref.transitionSeconds,
    children = _ref.children;
  var _useState = useState(visible),
    _useState2 = _slicedToArray(_useState, 2),
    displayed = _useState2[0],
    setDisplayed = _useState2[1];
  var innerStyle = useMemo(function () {
    if (!transitionSeconds) return style;
    return _objectSpread(_objectSpread({}, style), {}, {
      transitionDuration: "".concat(transitionSeconds, "s")
    });
  }, [style, transitionSeconds]);
  useEffect(function () {
    var timeout;
    if (visible) {
      setDisplayed(true);
    } else {
      timeout = setTimeout(function () {
        setDisplayed(false);
      }, (transitionSeconds || DEFAULT_TRANSITION_SECONDS) * 1000);
    }
    return function () {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [transitionSeconds, visible]);
  return /*#__PURE__*/jsx("div", {
    className: ConditionalVisibleClassNames.block({
      visible: visible,
      displayed: visible || displayed
    }, className),
    style: innerStyle,
    children: children
  });
}
ConditionalVisible.defaultProps = {
  className: '',
  style: {},
  visible: false,
  transitionSeconds: null,
  children: []
};

export { ConditionalVisible as default };
//# sourceMappingURL=ConditionalVisible.js.map
